import { render, staticRenderFns } from "./IncomeRestaurant.vue?vue&type=template&id=225a3ab2&"
import script from "./IncomeRestaurant.vue?vue&type=script&lang=js&"
export * from "./IncomeRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./IncomeRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports